import { constants, mediaQueryStyles } from "@newsela/angelou";

const { mediaQuery } = mediaQueryStyles;
const {
  BreakpointNames: { md },
} = constants.breakpoints;

const {
  colors: { ui },
} = constants;

export const buttonCss = (isLanguageSelectorVisible: boolean) => ({
  ...(isLanguageSelectorVisible
    ? {
        borderTopLeftRadius: 0,
        borderBottomLeftRadius: 0,
      }
    : {}),

  [mediaQuery.upTo(md)]: {
    height: "32px",
  },
});

export const disabledButtonCss = {
  border: `1px ${ui.neutral[100]} solid`,
};

export const dropdownCss = {
  width: "136px",
};
